import ReactMarkdown from 'react-markdown'

import styles from './styles.module.scss'

const allowedElements = [
  'a',
  'blockquote',
  'br',
  'code',
  'em',
  'h1',
  'h2',
  'h3',
  'h4',
  'hr',
  'img',
  'li',
  'ol',
  'p',
  'pre',
  'strong',
  'ul',
]

interface MarkdownProps {
  source: string,
  style?: object,
}

const Markdown = (props: MarkdownProps) => {
  const { source, style } = props

  return (
    <div className={styles.root} style={style}>
      <ReactMarkdown allowedElements={allowedElements} skipHtml>
        {source}
      </ReactMarkdown>
    </div>
  )
}

export default Markdown
